export default __webpack_public_path__ + "static/media/mobx.9d00f6d4.svg";